import { render, staticRenderFns } from "./fleet-column-description.vue?vue&type=template&id=2015c9eb&scoped=true&"
import script from "./fleet-column-description.vue?vue&type=script&lang=js&"
export * from "./fleet-column-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015c9eb",
  null
  
)

export default component.exports